import React from 'react'
import ImageUtils from '../../../utils/img.utils'
import Button from '../button'
import Typography from '../typography'
import { SubscribeBottomCTA } from './style'

const Subscribe = (props: any) => {
  if (props.data) {
    const postHeadline = props.data.postHeadline ? props.data.postHeadline : ''

    let backgroundDesktopUrl = ImageUtils.getResizedImageUrl(
      'https://images.ctfassets.net/5965pury2lcm/7IFUtInC8kyPBw8YZGvbId/c0eb86d7d29130b8e08e8d9b8b83f8f5/MainCTA-LG-MD.png',
      ''
    )
    let backgroundMobileUrl = ImageUtils.getResizedImageUrl(
      'https://images.ctfassets.net/5965pury2lcm/4Jh9GmFfspu4LTyHp5fGEv/803f9c7cf5baeeb3299f21fcc12e7e3d/MainCTA-SM-XS.png',
      ''
    )

    return (
      <SubscribeBottomCTA
        backgroundDesktop={backgroundDesktopUrl}
        backgroundMobile={backgroundMobileUrl}
        data-cy="Subscribe">
        <div>
          {postHeadline && <Typography type="header2">{postHeadline}</Typography>}

          <Button
            icon={true}
            href="/"
            text="Subscribe"
            type="primary"
            size="small"
            theme="light"
            className="SubscribeModal__Trigger"
          />
        </div>
      </SubscribeBottomCTA>
    )
  } else {
    return null
  }
}

export default Subscribe
